<template>
  <div class="row container" style="margin:auto">
    <div class="col l6 s12 center">
      <div id="signinDiv" class="smallDiv roundedBorder secondary-bg">
        <img src="../assets/lockerApp_ico_180.png" class="locker-logo" alt="lockerapp logo" />

        <div class="row">
          <div class="input-field col s12 primary-color">
            <input
              v-on:keyup.enter="loginClicked"
              id="email"
              type="email"
              class="validate primary-fg"
            />
            <label for="email">Email</label>
          </div>
        </div>

        <div class="row">
          <div class="input-field col s12 primary-color">
            <input
              v-on:keyup.enter="loginClicked"
              id="password"
              type="password"
              class="validate primary-fg"
            />
            <label for="password">Password</label>
          </div>
        </div>

        <div class="row">
          <div class="col s12">
            <a v-on:click="forgotPasswordClicked()" class="col s12">Forgot password?</a>
          </div>
        </div>

        <a
          class="waves-effect waves-light btn-large primary-bg"
          style="width:100%"
          v-on:click="loginClicked"
        >Login</a>

        <p class="primary-fg">
          Don't have an account?
          <router-link to="/signup">
            <a id="signup">
              Sign up
              here
            </a>
          </router-link>
        </p>
      </div>
    </div>

    <div id="about" class="col l6 m12 s12">
      <div id="aboutDiv" class="smallDiv roundedBorder secondary-bg">
        <h3 class="primary-fg">About LockerApp</h3>
        <p class="primary-fg">
          LockerApp is a
          <b class="secondary-fg">mobile / web application</b> that lets you protect your
          <b class="text-primary">passwords</b>
          of your social
          media accounts, email accounts and much more, you can store hidden notes as well.
        </p>

        <router-link to="/about">
          <a class="waves-effect waves-light btn-small primary-bg">
            <i class="material-icons left">more_horiz</i>Read more
          </a>
        </router-link>

        <p></p>
        <a
          class="waves-effect waves-light btn-small primary-bg"
          href="mailto:lockerApp.contact@gmail.com?subject=LockerApp contact&body=Dear LockerApp Team,"
        >
          <i class="material-icons left">contact_mail</i>Contact
        </a>
        <p></p>
        <router-link to="/passwordgenerator">
          <a class="waves-effect waves-light btn-small primary-bg">
            <i class="material-icons left">security</i>Password generator
          </a>
        </router-link>

        <p></p>
      </div>

      <div class="row">
        <img
          onclick="window.open('https://play.google.com/store/apps/details?id=com.lockerapp', '_blank');"
          src="../assets/google-play-badge.png"
          class="col l12 m6 s12"
          alt="google play store badge"
        />
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import 'firebase/auth'
import M from "materialize-css";
const LOGIN_DATA_API_ENDPOINT =
  process.env.NODE_ENV === "production"
    ? "/api/loginData"
    : "http://localhost:7777/api/loginData";
export default {
  name: "Signin",
  components: {},
  methods: {
    loginClicked: function () {
      let vueInstance = this;
      //Get the email and password.
      let email = document.getElementById("email");
      let password = document.getElementById("password");
      firebase
        .auth()
        .signInWithEmailAndPassword(email.value, password.value)
        .then(async function () {
          // user signed in
          /* Check for verification */
          if (!firebase.auth().currentUser.emailVerified) {
            /* give an alert and log the user out */
            alert("Please check your mailbox and verify your account.");
            firebase.auth().signOut();
          } else {
            let idToken = await vueInstance.getIdToken();
            const options = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: idToken,
              }
            };
            await fetch(LOGIN_DATA_API_ENDPOINT, options)
            localStorage.lockerApp_lastUsedEmail = JSON.stringify(email.value);
            vueInstance.$router.push("Passwords");
          }
        })
        .catch(function (error) {
          //An error occurred
          var errorMessage = error.message;
          alert(errorMessage);
        });
    },
    forgotPasswordClicked: function(){
      let emailAddress = document.getElementById("email").value;
      if (emailAddress == "") {
          M.toast(
            {
              html: 'Enter your email address and we will send you a link to reset your password.',
              displayLength: 4000
            }
          )
      } else {
          // Send recovery email to the entered email
          firebase.auth().sendPasswordResetEmail(emailAddress).then(function () {
              // Email sent
              M.toast(
                {
                  html: `Sent a password recovery link to ${emailAddress}.`,
                  displayLength: 4000
                }
              )
          }).catch(function (error) {              
              M.toast(
                {
                  html: `An error occured: ${error.message}.`,
                  displayLength: 5000
                }
              )
          });
          
      }
    },
    getIdToken: async function () {
      let idToken = await firebase
        .auth()
        .currentUser.getIdToken(false)
        .then(function (idToken) {
          return idToken;
        })
        .catch(function (error) {
          // Handle error
          console.error(
            `Failed while fetching the idToken from the firebase: ${error.meesage}`
          );
        });
      return idToken;
    },
  },
  mounted: function () {
    // If there is a user navigate to the passwords
    if (firebase.auth().currentUser){
      this.$router.push('passwords')
    }
  },
  metaInfo: {
    title: 'Sign in',
    meta: [
      {name: 'description', content: 'LockerApp is a password manager that lets you protect the passwords of your social media accounts, email accounts, and much more, you can keep your notes secret as well. | LockerApp | Password Manager | Encrypted Passwords | Encrypted Notes | Generate a new strong password'},
      {name: 'application-name', content: 'LockerApp'},
      {name: 'author', content: 'Emre Biçer'},
      {name: 'keywords', content: 'LockerApp, Signin, Sign in, Login, Log in, Locker App, Locker, App, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application'}
    ]
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smallDiv {
  padding: 20px;
  margin: auto;
  margin-bottom: 20px;
}
.locker-logo {
  width:180px;
  height:180px;
  border: 2px solid white;
  border-radius: 100%;
}
</style>
